module.exports = __webpack_public_path__ + "static/media/35_tn.945f0eaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/35_tn.jpg
// module id = 173
// module chunks = 0